import * as THREE from 'three';
import { skyTex } from './ground';

/* ============================================================
   環境反射圖 —— 濕地與鋼材要反射的東西
   ============================================================

   使用者 2026-08-04 在質感這一輪選了「地面局部積水反射」。反射要成立，
   得先有**被反射的東西**：這裡把天空漸層（`skyTex()`）過一次 PMREM，
   變成一張可以用粗糙度取樣的環境圖。

   為什麼用天空而不是真的反射場景：真反射要嘛第二次渲染整個場景
   （俯視遊戲下成本直接翻倍），要嘛用螢幕空間反射（r128 的 `SSRPass`
   在這個畫面上會在每個物件邊緣留下拖尾）。而**夜裡的濕柏油反射的
   本來就幾乎只有天空與地平線那條光** —— 這是物理上正確的近似，不是省事。

   ⚠️ **只掛在該有反射的材質上，不要設成 `scene.environment`。**
   後者會把 IBL 加到場上每一個 `MeshStandardMaterial`（含敵人與機體），
   整體亮度會跳一階，而使用者剛驗收過的冷夜配色是照現在這組光訂的。 */

var _env: any = null;
var _done = false;

/** 建立環境圖。要在 renderer 建好之後呼叫（PMREM 需要 GL context）。
    `renderer` 為 null（headless）時回 null，呼叫端自己擋掉。 */
export function initEnv(renderer: any) {
  if (_done) return _env;
  _done = true;
  if (!renderer) return null;
  var sky = skyTex();
  if (!sky) return null;
  /* 天空球本身用的是同一張圖，那邊是貼在球內側；這裡要當**等距柱狀**
     來源，所以 mapping 得換。兩者共用同一個 canvas 沒問題（貼圖物件不同）。 */
  var eq = sky.clone();
  eq.mapping = THREE.EquirectangularReflectionMapping;
  eq.needsUpdate = true;
  var pmrem = new THREE.PMREMGenerator(renderer);
  pmrem.compileEquirectangularShader();
  _env = pmrem.fromEquirectangular(eq).texture;
  pmrem.dispose();
  return _env;
}

export function envMap() { return _env; }
